import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import styles from './marketing.module.css';

interface EyebrowProps {
  children: ReactNode;
  /** `secondary` (default) uses supporting ink; `inherit` takes the surrounding colour. */
  tone?: 'secondary' | 'inherit';
  className?: string;
}

/** The small uppercase label above a section heading. */
export function Eyebrow({
  children,
  tone = 'secondary',
  className,
}: EyebrowProps): React.ReactElement {
  return (
    <p className={clsx(styles.eyebrow, tone === 'secondary' && styles.eyebrowSecondary, className)}>
      {children}
    </p>
  );
}
